import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherIconDirective } from '../../directives/feather-icon.directive';
import { ImagePreviewService } from '../../services/image-preview.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-image-preview-overlay',
  standalone: true,
  imports: [CommonModule, FeatherIconDirective],
  template: `
    @if (preview.url(); as src) {
      <div
        class="img-preview-overlay"
        role="dialog"
        aria-modal="true"
        [attr.aria-label]="closeLabel"
        (click)="preview.close()"
      >
        <button
          type="button"
          class="img-preview-close"
          (click)="preview.close(); $event.stopPropagation()"
          [attr.aria-label]="closeLabel"
          [attr.title]="closeLabel"
        >
          <span appFeather="x" size="22"></span>
        </button>
        <img
          class="img-preview-full"
          [src]="src"
          alt=""
          (click)="$event.stopPropagation()"
        />
      </div>
    }
  `,
  styles: [`
    :host {
      display: contents;
    }

    .img-preview-overlay {
      position: fixed;
      inset: 0;
      z-index: 12000;
      background: rgba(0, 0, 0, 0.88);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right))
        max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));
      cursor: zoom-out;
      box-sizing: border-box;
    }

    .img-preview-close {
      position: absolute;
      top: max(12px, env(safe-area-inset-top));
      right: max(12px, env(safe-area-inset-right));
      width: 44px;
      height: 44px;
      border: none;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.14);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 1;
      transition: background 0.15s;
    }

    .img-preview-close:hover,
    .img-preview-close:focus-visible {
      background: rgba(255, 255, 255, 0.26);
      outline: none;
    }

    .img-preview-full {
      max-width: min(100%, 96vw);
      max-height: min(100%, 92vh);
      width: auto;
      height: auto;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
      cursor: default;
      background: transparent;
      -webkit-user-drag: none;
      user-select: none;
    }
  `]
})
export class ImagePreviewOverlayComponent {
  readonly preview = inject(ImagePreviewService);
  private readonly langSvc = inject(LanguageService);

  get closeLabel(): string {
    return this.langSvc.t('close') || 'Close';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.preview.url()) this.preview.close();
  }
}
